import { Component, OnInit, ViewChild } from "@angular/core";
import { Headers, Http, Response } from "@angular/http";

import { Task } from "./shared/task.model";
import { TaskService } from "./shared/task.service";

import { Subject } from 'rxjs/Subject';

import 'rxjs/add/operator/map';
import {Message, ConfirmationService} from 'primeng/api';

@Component({
  selector: "tasks",
  templateUrl: "./tasks.component.html",
  styleUrls: ["./tasks.component.css"],
  //ESTE PROVIDERS ESTÁ SENDO DECLARADO NO APP.MODULE.TS
  //providers: [TaskService] //DECLARAÇÃO SIMPLES, MAIS COMUM
  //OU
  //providers: [
  //{ provide: TaskService, useClass: TaskService } //DECLARAÇÃO VERBOSA, NÃO MUITO COMUM
  //]
  providers: [ConfirmationService]
})
export class TasksComponent implements OnInit {
  /** ATRIBUTO */
  public tasks: Array<Task>;
  public newTask: Task;

  public cols: any[];
  public aux = 0;
  public StyleSortId;
  public StyleSortTitle;

  public msgs:   Message[] = [];

  public avisos: Message[] = [];

  public selectedValues: Task[] = [];

  public idsToDelete: any[] = [];

  uploadedFiles: any[] = [];
  @ViewChild('fileInput') fileInput;

  public progresso: number = 0;

  // MÉTODO CONSTRUTOR
  public constructor(
    private http: Http,
    private taskService: TaskService,
    private confirmationService: ConfirmationService
    ) {
    this.newTask = new Task(null, ''); //CRIA UMA TASK VAZIA
  }

  /** MÉTODO PRINCIPAL */
  public ngOnInit() {

    this.cols = [
      { field: 'id', header: 'ID' },
      { field: 'title', header: 'Título' }
    ];

     this.taskService.getAll()
       .subscribe(
         (tasks) => {

            this.tasks = tasks; 

           //console.log("Vindo do banco: "+tasks)
          },
         error => {
           setTimeout(() => {
            this.avisos = [];
            this.avisos.push({severity:'info', summary:'Atenção', detail:'Nenunha tarefa cadastrada!'});
           }, 500);
          
         }
       )
  }

  /**
   * createTask
   */
  public createTask() {
    this.newTask.title = this.newTask.title.trim(); //LIMPA OS CAMPOS VAZIOS DO INICIO E FIM DO VALOR ADICIONADO

    if(!this.newTask.title){
        alert("A tarefa tem que ter um título.");
    }else{
      this.taskService.create(this.newTask)
        .subscribe(
          (task) => {

              this.msgs = [];
              this.msgs.push(
                {severity:'success', 
                 summary:'Ação Completada', 
                 detail:'A tarefa foi cadastrada com sucesso.'
                });
            //this.tasks.push(task); //ADD NOVA TAREFA NO FIM DO ARRAY
            //if(this.tasks.length == 0){
               //ADD NOVA TAREFA NO INICIO DO ARRAY
               //this.tasks.push(task);
            //}else{
             // this.tasks.unshift(task);
            //}
            //if(this.idsToDelete.length == this.tasks.length){
             // this.tasks = [];
            //}
            this.ngOnInit();
            //console.log(task);
            this.newTask = new Task(null, ''); //LIMPAR OS CAMPOS
            
          },
          () => alert("Ocorreu um erro no servidor, tente mais tarde. FILE: tasks.componet")
        )
    }

  }

  /**
   * deleteTask
   * MÉTODO RESPONSÁVEL POR DELETAR UMA TAREFA
   */
  public deleteTask(task: Task) {

    //if(confirm(`Deseja realmente excluir a tarefa "${task.title}"`)){
    //   this.taskService.delete(task.id)
    //       .subscribe(
    //         () => {
    //           this.tasks = this.tasks.filter(t => t !== task);
    //           alert("Excluído com sucesso!");
    //         },
    //         () => "Erro ao excluir tarefa!!!"
    //       )
    // }

      this.confirmationService.confirm({
        message: 'Você deseja realmente excluir esta tarefa: ' + task.title + '?',
        header: 'Confirmar Exclusão',
        icon: 'fa fa-trash',
        accept: () => {
          this.taskService.delete(task.id)
          .subscribe(
            () => {
              this.tasks = this.tasks.filter(t => t !== task);
              //alert("Excluído com sucesso!");
              this.msgs = [];
              this.msgs.push(
                {severity:'success', 
                 summary:'Ação Completada', 
                 detail:'A tarefa foi excluída com sucesso.'
                });
            },
            () => this.msgs.push({severity:'error', summary:'Ação Não Completada', detail:'Desculpe, erro ao tentar excluir tarefa.'})
          )
        },
        reject: () => {
          this.msgs = [{severity:'info', summary:'Ação Cancelada', detail:'Você cancelou a ação de exclusão'}];
        }
      });
    
  }

  public setIdsToDelete(){

    if(this.selectedValues.length > 0){
       this.selectedValues.forEach(element => {
          this.idsToDelete.push(
            element.id
          );
      });
      console.log("Seleção passada: "  + this.selectedValues);
      console.log("Ids selecionados: " + this.idsToDelete);
    }else{
      this.idsToDelete = [];
      console.log("Nem um valor selecionado.");
    }

  }

  /** MÉTODO PARA DELETAR AS TAREFAS SELECIONADAS **/
  public deleteSelected(){
    //CHAMA O MÉTODO DE SETAR OS ISD PARA DELETAR
    this.setIdsToDelete();

    if(this.idsToDelete.length ==0){

      this.msgs = [];
      this.msgs.push({severity:'warn', summary:'Atenção', detail:'Escolha pelo menos uma tarefa para execultar esta ação.'});
      this.selectedValues = [];
      this.idsToDelete    = [];
      
    }else{

      this.confirmationService.confirm({
        message: 'Você deseja realmente excluir estas tarefas: ' + this.idsToDelete + '?',
        header: 'Confirmar Exclusão',
        icon: 'fa fa-trash',
        accept: () => {
          this.taskService.deleteMultiplos(this.idsToDelete)
          .subscribe(
            () => {
              //this.tasks = this.tasks.filter(t => t.id !== );
              //this.tasks = [];
              this.ngOnInit();
              //alert("Excluído com sucesso!");
              this.msgs = [];
              this.msgs.push(
                {severity:'success', 
                summary:'Ação Completada', 
                detail:'As tarefas foram excluídas com sucesso.'
                });

                this.selectedValues = [];
                this.idsToDelete    = [];
            },
            () =>{
              
                this.msgs.push({severity:'error', summary:'Ação Não Completada', detail:'Desculpe, erro ao tentar excluir tarefas.'});
                this.selectedValues = [];
                this.idsToDelete    = [];
            } 
          )
        },
        reject: () => {
          this.msgs = [{severity:'info', summary:'Ação Cancelada', detail:'Você cancelou a ação de exclusão'}];
          this.selectedValues = [];
          this.idsToDelete    = [];
        }
      });
    }

  }

  public ordenarCrescente( num, tasks){

    this.StyleSortTitle = ""
    this.StyleSortId    = "red"

    this.aux += num;

    let b = (this.aux) % 2;

    if( b != 0){
      tasks.sort(function(a, b){return parseFloat(a.id) - parseFloat(b.id);}); //retorna array em ordem crescente;
    }else{
      this.ordenarDecrescente(tasks);
    }
    
  }

  public ordenarDecrescente(tasks){

    tasks.sort(function(a, b){return parseFloat(b.id) - parseFloat(a.id);}); //retorna array em ordem crescente;

  }

  public ordenarCrescenteTexto(num, tasks){

    this.StyleSortId    = ""
    this.StyleSortTitle = "red"

    this.aux += num;

    let b = (this.aux) % 2;

    if( b != 0){
      // sort by name
      tasks.sort(function(a, b) {
        var nameA = a.title.toUpperCase(); // ignore upper and lowercase
        var nameB = b.title.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }
    else{
      this.ordenarDecrescenteTexto(tasks);
    }

  }

  public ordenarDecrescenteTexto(tasks){

    // sort by name
    tasks.sort(function(a, b) {
      var nameA = a.title.toUpperCase(); // ignore upper and lowercase
      var nameB = b.title.toUpperCase(); // ignore upper and lowercase
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

  }

  onUpload(event) {
    console.log("Entrou no onUpload");

    

    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    this.msgs = [];
    this.msgs.push({severity: 'success', summary: 'Ação concluída', detail: 'O arquivo foi carregado com sucesso.'});

  }

  onProgress(event){

    

    console.log("Evento: "+event);
    console.log("Carregando...");


    let totalSize  = event.originalEvent.total;
    let carregando = event.originalEvent.loaded;

    let percent = (carregando / totalSize) * 100;

    this.progresso = percent;

    console.log(event);

    if(carregando == totalSize){

      this.progresso = 100;

      setInterval(()=>{
        this.progresso = 0;
      }, 2000)
    }

  }

    //http://www.bentedder.com/upload-images-angular-4-without-plugin/
    //https://valor-software.com/ng2-file-upload/
    //https://www.npmjs.com/package/angular4-files-upload
    //https://www.youtube.com/watch?v=FI7bzIuPous
    // upload() {
    //   let fileBrowser = this.fileInput.nativeElement;
    //   if (fileBrowser.files && fileBrowser.files[0]) {
    //     const formData = new FormData();
    //     formData.append("selectFile", fileBrowser.files[0], fileBrowser.name);

    //     console.log(formData);

    //     this.taskService.upload(formData).subscribe(res => {
    //       console.log("Upandado");
    //     });
    //   }
    // }  

}



// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/tasks/tasks.component.ts